import React from 'react';
import { Tooltip, Form, List, Card, Tabs, Menu, Select, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';


const toolPaneHOC = (reducer) =>
  (WrappedComponent) => {
    // ...and returns another component...
    class Wrapper extends React.Component {
      render() {
        const { title, onClose } = this.props;
        return (
          <Layout.Sider
            className="vb-theme--toolbox"
            width={400}
            theme="dark"
            style={{ position: 'relative', zIndex: '2' }}
          >
            <Row
              type="flex"
              style={{
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                background: '#1A2B3A',
                flexWrap: 'nowrap',
              }}
            >
              <Col>
                <Row
                  style={{ height: '64px', padding: '16px', borderBottom: '1px solid #405160' }}
                  type="flex"
                  justify="space-between"
                  align="middle"
                >
                  <Col style={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '16px' }}>{title}</Col>
                  <Col />
                  <Col><Button size="small" icon="close" ghost shape="circle" onClick={onClose} /></Col>
                </Row>
              </Col>
              <Col style={{ flex: '1', padding: '0', overflow: 'hidden' }}>
                {<WrappedComponent {...this.props} />}
              </Col>
            </Row>
          </Layout.Sider>
        );
      }
    }

    return Wrapper;
  }
;

export default toolPaneHOC;
